import { Box, Typography } from '@mui/material';
import type { ElementType } from 'react';

import { TypographyIcon } from '../TypographyIcon/TypographyIcon';

type Props = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  icon?: ElementType;
};

export const DrawerHeader = ({ title, subtitle, icon }: Props) => {
  return (
    <Box mb={4}>
      {icon ? (
        <TypographyIcon variant="h5" size="large" icon={icon}>
          {title}
        </TypographyIcon>
      ) : (
        <Typography variant="h5">{title}</Typography>
      )}
      {subtitle ? <Typography>{subtitle}</Typography> : null}
    </Box>
  );
};
